import { BoardId } from "../constants/board-id";

export class ExportPostsReviewToggleHandler {
    /**
     * The "include review question IDs" toggle only means anything for
     * board_id="review" posts (see ExportService::downloadPosts()); hide it
     * for every other board selection instead of leaving a dead control visible.
     */
    public applyVisibility(select: HTMLSelectElement, field: HTMLElement): void {
        field.hidden = select.value !== BoardId.REVIEW;
    }
}
